import { render, staticRenderFns } from "./TwentyFiveTable.vue?vue&type=template&id=767cdd15&"
import script from "./TwentyFiveTable.vue?vue&type=script&lang=js&"
export * from "./TwentyFiveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports